import { useEffect } from "react";

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} - Farhan Hasin Dipro`;
  }, [title]);
};

export default useTitle;
